import React, { useState, useEffect } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import LoginIcon from "@mui/icons-material/Login";
import "./PublicLayout.scss";

const NAV_ITEMS = [
  { label: "Privacy Policy", path: "/public/privacy-policy" },
  { label: "Terms & Conditions", path: "/public/terms-and-conditions" },
  { label: "Security Policy", path: "/public/security-policy" },
  { label: "FAQ", path: "/public/faq" },
  { label: "Support", path: "/public/support" },
];

export default function PublicLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="public_layout">
      {/* Sticky Header */}
      <header className="public_header">
        <div className="header_inner">
          <div
            className="brand_logo"
            onClick={() => navigate("/public/privacy-policy")}
            role="button"
            tabIndex={0}
          >
            <h1 className="brand_title">
              It's My <span className="brand_accent">Wall</span>
            </h1>
          </div>

          <nav className="nav_links" aria-label="Public Navigation">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `nav_item ${isActive ? "active" : ""}`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="header_actions">
            <button
              className="btn_signin"
              onClick={() => navigate("/")}
              title="Go to Admin Sign In"
            >
              <LoginIcon sx={{ fontSize: 16 }} />
              <span>Sign In</span>
            </button>

            <button
              className="mobile_toggle"
              onClick={() => setMobileMenuOpen((prev) => !prev)}
              aria-label="Toggle navigation menu"
            >
              {mobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Drawer */}
        <div className={`mobile_nav_menu ${mobileMenuOpen ? "open" : ""}`}>
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `mobile_nav_item ${isActive ? "active" : ""}`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <button
            className="mobile_signin"
            onClick={() => navigate("/")}
          >
            Sign In to Account
          </button>
        </div>
      </header>

      {/* Main Content Rendered by Child Route */}
      <main className="public_main">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="public_footer">
        <div className="footer_inner">
          <div className="footer_top">
            <div className="footer_brand">
              <div className="footer_logo">
                It's My <span>Wall</span>
              </div>
              <p className="footer_tagline">
                AI-powered interior wall design & decor platform.
              </p>
            </div>

            <div className="footer_nav">
              {NAV_ITEMS.map((item) => (
                <NavLink key={item.path} to={item.path}>
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>

          <div className="footer_bottom">
            <p className="copyright">
              © {new Date().getFullYear()} It's My Wall. All rights reserved.
            </p>

            <button
              className="back_to_top"
              onClick={scrollToTop}
              title="Back to top"
            >
              <span>Back to top</span>
              <KeyboardArrowUpIcon />
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
}
